import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { BRANDING, ICONS } from '../../../core/constants/branding.constants';
import { AccountService } from '../../../core/services/account.service';
import { TokenManagerService } from '../../../core/services/token-manager.service';
import { UsersService } from '../../../core/services/users.service';
import { BuildVersionComponent } from '../../../shared/components/build-version/build-version.component';

@Component({
  selector: 'app-login-page',
  imports: [ReactiveFormsModule, CommonModule, BuildVersionComponent],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent implements OnInit{
  readonly branding = BRANDING;
  readonly icons = ICONS;

  passwordVisible: boolean = false;
  loginForm: FormGroup;
  returnUrl = '/dash';
  emailFocused: boolean = false;
  passwordFocused: boolean = false;

  constructor(
    private fb: FormBuilder,
    private accountService: AccountService,
    private userService: UsersService,
    private tokenManager: TokenManagerService,
    private route: Router,
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[\\W_]).+')
      ]]
    });
  }

  ngOnInit(): void {
    if (this.tokenManager.isLogged()) {
      this.route.navigateByUrl(this.returnUrl);
    }
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.accountService.login(this.loginForm.value).subscribe({
        next: (user) => {
          this.userService.getUserInfo().subscribe(res => {
            this.route.navigateByUrl(this.returnUrl);
          });
        }
      });
    }
  }

  navigateToRecuperarSenha() {
    this.route.navigateByUrl('/account/recuperar-senha');
  }
}
